/**
 * Fußbereich der Willkommensseite: Logo, Tagline und Links (Req 2.2).
 *
 * Der Konzept-/Platzhalter-Hinweis kennzeichnet, dass rechtliche Angaben und
 * Teile der Seite vor der Veröffentlichung noch anzupassen sind (Req 13.3).
 */

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { useI18n } from "../../i18n/I18nProvider";
import { welcomeColors } from "./welcomeTheme";
import { WelcomeLogo, scrollToAnchor } from "./welcomeShared";

export default function WelcomeFooter() {
  const { t } = useI18n();
  const theme = useTheme();
  const colors = welcomeColors(theme.palette.mode);

  return (
    <Box
      component="footer"
      sx={{ borderTop: `1px solid ${colors.border}`, py: 4, bgcolor: "background.paper" }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          alignItems={{ xs: "flex-start", sm: "center" }}
          justifyContent="space-between"
        >
          <WelcomeLogo
            width={140}
            src="/se-group-appbar-hell.png"
            srcDark="/se-group-appbar-dunkel.png"
          />
          <Typography variant="body2" color="text.secondary">
            {t("welcome.footer.tagline")}
          </Typography>
          <Stack direction="row" spacing={2}>
            <Button
              size="small"
              color="inherit"
              href="#fragen"
              onClick={scrollToAnchor}
              sx={{ minHeight: 44 }}
            >
              {t("welcome.footer.faq")}
            </Button>
          </Stack>
        </Stack>
        <Divider sx={{ my: 2.5, borderColor: colors.border }} />
        <Typography variant="caption" color="text.secondary">
          {t("welcome.footer.note", { year: new Date().getFullYear() })}
        </Typography>
      </Container>
    </Box>
  );
}
